import React from 'react';
import * as Sentry from "@sentry/react";
import { version } from '../package.json';

Sentry.init({
    dsn: "https://d2db120e414893d4f2693b5ed3db8750@o4510761946906624.ingest.us.sentry.io/4511520378519553",
    enabled: !import.meta.env.DEV,
    release: version,
    environment: import.meta.env.VITE_APP_ENVIRONMENT ?? import.meta.env.MODE,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration()
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true
});

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/App';

import {isChrome, isChromium, isEdge, isOpera, browserName, fullBrowserVersion, isFirefox} from "react-device-detect";
import Logo from "./util/Logo";

let isSupported = isChrome || isChromium || isOpera || isFirefox || isEdge || browserName === "Brave";

const container = document.getElementById('root');
const root = createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn("Uncaught error", error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
    <div id="page-handle">
        {isSupported ? <App/> : (
            <div className="not-supported">
                <div style={{margin: "20px auto", maxWidth: "225px"}}>
                    <Logo/>
                </div>
                <p>Jurybox does not currently support your browser, {browserName} ({fullBrowserVersion}).</p>
                <p>
                    Please use the latest version
                    of <a href={"https://www.google.com/chrome/"}>Chrome</a>, &nbsp;
                    <a href={"https://www.microsoft.com/en-us/edge/download"}>Edge</a>,&nbsp;
                    <a href={"https://brave.com/"}>Brave</a>, or &nbsp;
                    <a href={"https://en.wikipedia.org/wiki/Chromium_(web_browser)"}>almost any Chromium based
                        browser</a>
                    &nbsp; to use this app.
                </p>
                <p>
                    <a href={"https://www.mozilla.org/en-US/firefox/new/"}>Firefox</a> is also partially
                    supported.
                </p>
            </div>
        )}
    </div>
);
